import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.875 2.62501V8.25001C10.8747 8.3034 10.863 8.35611 10.8407 8.40461C10.8184 8.45311 10.786 8.49629 10.7456 8.53126C10.0294 9.15142 9.34453 9.37501 8.69156 9.37501C7.80516 9.37501 6.97734 8.96532 6.20719 8.58517C4.96266 7.96876 3.88078 7.43485 2.625 8.42673V10.5C2.625 10.5995 2.58549 10.6948 2.51516 10.7652C2.44484 10.8355 2.34946 10.875 2.25 10.875C2.15054 10.875 2.05516 10.8355 1.98484 10.7652C1.91451 10.6948 1.875 10.5995 1.875 10.5V2.62501C1.87536 2.57159 1.88713 2.51886 1.90952 2.47035C1.93192 2.42185 1.96442 2.37869 2.00484 2.34376C3.69234 0.882197 5.20687 1.63079 6.54187 2.29126C7.82812 2.92782 8.94328 3.47813 10.2544 2.34376C10.3086 2.29678 10.3751 2.26633 10.4461 2.25602C10.517 2.2457 10.5895 2.25595 10.6548 2.28555C10.7201 2.31515 10.7756 2.36287 10.8146 2.42303C10.8536 2.4832 10.8746 2.55329 10.875 2.62501Z",
		fill: "currentColor"
	})
});
export default SvgFlag;
